import { Ico } from "../../../components/icons/icons.jsx";

function StructureCell({ label, value, dark, c }) {
  return (
    <div
      style={{
        padding: "10px 12px",
        borderRadius: 8,
        border: `1px solid ${c.cardBdr}`,
        background: dark ? "rgba(255,255,255,0.03)" : c.card,
        minWidth: 0,
      }}
    >
      <p style={{ fontSize: 10, fontWeight: 700, color: c.sub, margin: 0, marginBottom: 4, textTransform: "uppercase", letterSpacing: "0.04em" }}>{label}</p>
      <p
        style={{
          fontSize: 13,
          fontWeight: 700,
          color: c.text,
          margin: 0,
          fontFamily: "var(--nm-font-mono)",
          letterSpacing: "0.02em",
          wordBreak: "break-all",
        }}
      >
        {value}
      </p>
    </div>
  );
}

function GhostBtn({ children, onClick, c, dark, accent, icon }) {
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        height: 32,
        padding: "0 12px",
        borderRadius: 8,
        border: `1px solid ${c.cardBdr}`,
        background: dark ? "rgba(255,255,255,0.04)" : c.card,
        color: accent ?? c.sub,
        fontSize: 12,
        fontWeight: 600,
        cursor: "pointer",
        fontFamily: "inherit",
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
      }}
    >
      {icon}
      {children}
    </button>
  );
}

export function CommandPreviewPanel({
  packet,
  previewExpanded,
  setPreviewExpanded,
  copied,
  copyPreview,
  saveNotice,
  onSave,
  saving,
  dark,
  c,
  A,
  theme,
  readOnly = false,
}) {
  const { rawHex, structure } = packet;

  return (
    <div style={theme.section}>
      <div
        style={{
          padding: "14px 16px",
          borderBottom: `1px solid ${c.cardBdr}`,
        }}
      >
        <p style={{ fontSize: 14, fontWeight: 700, color: c.text, margin: 0 }}>Command Preview</p>
        <p style={{ fontSize: 12, color: c.sub, margin: "4px 0 0", lineHeight: 1.45 }}>
          Encoded packet and field breakdown. Expand to view command structure.
        </p>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          gap: 8,
          padding: "10px 16px",
          borderBottom: `1px solid ${c.cardBdr}`,
          background: dark ? "rgba(0,0,0,0.06)" : "rgba(0,0,0,0.012)",
        }}
      >
        {saveNotice && <span style={{ fontSize: 11, fontWeight: 600, color: "#22C55E", marginRight: "auto" }}>{saveNotice}</span>}
        <GhostBtn dark={dark} onClick={() => setPreviewExpanded((v) => !v)} c={c}>
          {previewExpanded ? "Collapse" : "Expand"}
        </GhostBtn>
        <GhostBtn dark={dark} onClick={copyPreview} c={c} accent={copied ? "#22C55E" : undefined} icon={copied ? Ico.check : Ico.copy}>
          {copied ? "Copied" : "Copy"}
        </GhostBtn>
      </div>

      <div style={{ padding: previewExpanded && structure.length > 0 ? "0 0 8px" : "0 0 12px" }}>
        <div style={{ margin: 8, padding: "10px 12px", borderRadius: 8, border: `1px solid ${c.cardBdr}`, background: dark ? "rgba(0,0,0,0.2)" : c.hover }}>
          <p style={{ fontSize: 10, fontWeight: 700, color: c.sub, margin: "0 0 6px", textTransform: "uppercase", letterSpacing: "0.04em" }}>Raw hex</p>
          <p
            style={{
              margin: 0,
              fontSize: 11,
              lineHeight: 1.6,
              color: c.text,
              fontFamily: "var(--nm-font-mono)",
              whiteSpace: previewExpanded ? "pre-wrap" : "nowrap",
              overflow: previewExpanded ? "visible" : "hidden",
              textOverflow: previewExpanded ? "clip" : "ellipsis",
              wordBreak: "break-all",
            }}
          >
            {rawHex}
          </p>
        </div>
      </div>

      {previewExpanded && structure.length > 0 && (
        <div style={{ borderTop: `1px solid ${c.cardBdr}`, marginBottom: 8 }}>
          <p style={{ fontSize: 11, fontWeight: 700, color: c.sub, margin: 0, padding: "10px 14px", textTransform: "uppercase", letterSpacing: "0.04em", borderBottom: `1px solid ${c.cardBdr}` }}>
            Command structure
          </p>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))",
              gap: 8,
              padding: 10,
            }}
          >
            {structure.map((field) => (
              <StructureCell key={field.label} label={field.label} value={field.value} dark={dark} c={c} />
            ))}
          </div>
        </div>
      )}

      {!readOnly && (
        <div
          style={{
            padding: "12px 16px 16px",
            borderTop: `1px solid ${c.cardBdr}`,
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <button
            type="button"
            onClick={onSave}
            disabled={saving}
            style={{
              height: 38,
              padding: "0 18px",
              borderRadius: 10,
              border: "none",
              background: A,
              color: "#fff",
              fontSize: 13,
              fontWeight: 700,
              cursor: saving ? "wait" : "pointer",
              fontFamily: "inherit",
              opacity: saving ? 0.7 : 1,
              boxShadow: `0 4px 14px ${A}44`,
            }}
          >
            {saving ? "Saving…" : "Save command"}
          </button>
        </div>
      )}
    </div>
  );
}
